import {decodeUrlParameters} from './helpers'

export const isServiceCatalog = () => {
  let {type} = decodeUrlParameters({
    searchString: window.location.search
  })

  // isCatalogView is true when the Service Catalog is the primary app view.
  return type && type === 'CATALOG'
}
